module.exports = __webpack_public_path__ + "assets/img/ground_repeat_bg_mob.jpg?c96ae51aa879b5bf5979156b6f70e22b";